"use client";

import Image from "next/image";
import YoutubeEmbed from "@/app/components/YoutubeEmbed";

const pilares = [
  {
    number: "01",
    title: "Viver pelo cliente",
    content: (
      <>
        <p className="mb-4">
          Nosso principal ativo são os{" "}
          <span className="text-secondary-main">clientes</span>. O Agibank só
          existe se conseguir{" "}
          <span className="text-secondary-main">
            resolver suas dores, entregando produtos e experiências melhores
          </span>{" "}
          que alternativas disponíveis no mercado.
        </p>
        <p>
          O resultado disso paga salários e os benefícios de quem trabalha aqui,
          além de remunerar o capital do acionista. Isso justifica a
          continuidade do negócio e dos novos investimentos para{" "}
          <span className="text-secondary-main">
            continuarmos crescendo juntos
          </span>
          .
        </p>
      </>
    ),
  },
  {
    number: "02",
    title: "Agir como empreendedor",
    content: (
      <>
        <p className="mb-4">
          Quantas empresas você conhece que cobram espírito de dono do time?
          Muitas, né? Mas quantas delas possibilitam que as pessoas sejam de
          fato donas?
        </p>
        <p>
          E não se trata de dar essa oportunidade para poucos, mas de tornar
          isso possível para todos. No Agibank é assim. Então,{" "}
          <span className="text-secondary-main">
            aqui ou você age como dono porque já é dono ou porque sonha em ser o
            próximo
          </span>
          .
        </p>
      </>
    ),
  },
  {
    number: "03",
    title: "Crescer na jornada",
    content: (
      <>
        <p className="mb-4">
          <span className="font-bold">Nossa cultura é forte</span>. Então, só
          faz sentido empreender aqui caso você identifique muito com ela.
        </p>
        <p>
          Se você é uma pessoa{" "}
          <span className="text-secondary-main">
            fanática por resultado, tem pavor de zona de conforto, vive em
            eterna busca por conhecimento, prefere as coisas ditas direto ao
            ponto e quer estar rodeada de pessoas que também são assim
          </span>
          , você vai curtir muito sua jornada aqui. Quem cresce com a gente,
          sabe que vai muito mais longe.
        </p>
      </>
    ),
  },
];

export default function CulturaJeitoAgi() {
  return (
    <section id="jeito-agi" className="py-16 lg:py-24 bg-blue-main relative overflow-hidden">
      {/* Floating pattern element */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-20 pointer-events-none">
        <Image
          src="/images/home/pattern-nossa-cultura.svg"
          alt=""
          width={300}
          height={300}
          className="w-[200px] lg:w-[300px] h-auto"
        />
      </div>

      <div className="container-default relative z-10">
        {/* Title */}
        <h2 className="text-[36px] lg:text-[48px] font-semibold text-center text-white mb-10 lg:mb-14">
          Conheça nossa cultura
        </h2>

        {/* Video container */}
        <div className="relative w-full mx-auto mb-14">
          <div className="relative aspect-video rounded-[20px] overflow-hidden bg-blue-dark shadow-2xl">
            <YoutubeEmbed videoId="p3UtQDknMQ8" title="Manifesto de Cultura Agibank" />
          </div>
        </div>

        {/* Pilares section */}
        <div>
          <h3 className="text-2xl lg:text-3xl font-semibold text-white mb-8">
            Nossos pilares:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 lg:mx-[-32px]">
            {pilares.map((pilar) => (
              <div
                key={pilar.number}
                className="flex flex-col p-6 lg:p-8 rounded-[30px]"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(0, 100, 245, 0.20) 0%, rgba(0, 51, 176, 0.08) 88.46%)",
                }}
              >
                <span className="text-secondary-main text-3xl lg:text-[39px] font-bold mb-4">
                  {pilar.number}
                </span>
                <h4 className="text-xl lg:text-3xl font-bold text-white mb-4">
                  {pilar.title}
                </h4>
                <div className="text-white text-[17px] lg:text-base leading-5">
                  {pilar.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
